import { FC, ReactNode } from 'react';
import { KatTooltip } from '@amzn/katal-react';

import styles from './LabelWithTooltip.module.css';

export type TooltipPosition = 'top' | 'bottom' | 'left' | 'right';

export interface LabelWithTooltipProps {
  label: string;
  tooltip: string;
  tooltipPosition?: TooltipPosition;
  children?: ReactNode;
}

/**
 * A bold form label paired with a Katal info-icon tooltip on hover.
 *
 * Renders an inline `kat-tooltip` next to the label text and applies CSS
 * overrides so the tooltip bubble left-anchors to the icon (instead of
 * Katal's default horizontal center) — this prevents the bubble from
 * clipping past a parent container's left edge when the label is short.
 *
 * Pass form-row affordances (e.g. a "View in CMS" link) as `children`;
 * they render inline at the end of the label row.
 */
export const LabelWithTooltip: FC<LabelWithTooltipProps> = ({
  label,
  tooltip,
  tooltipPosition = 'top',
  children,
}) => (
  <div className={styles.fieldLabelRow} data-testid="label-with-tooltip">
    <label className={styles.fieldLabel}>{label}</label>
    <KatTooltip
      label={tooltip}
      triggerIcon="info_outline"
      size="small"
      position={tooltipPosition}
      data-testid="label-with-tooltip-tooltip"
    />
    {children}
  </div>
);
